export class WFESpecialHandlingResultDto {
    specialHandlingId: number;
    displayText: string;
    sequence: number;
}
